import { combineReducers } from "redux";
import matchesReducer from "./matchesReducer";
import teamsReducer from "./teamsReducer";
import leagueReducer from "./leagueReducer";
import statusesReducer from "./statusesReducer";

const rootReducer = combineReducers({
    leagueReducer,
    matchesReducer,
    teamsReducer,
    statusesReducer,
});

export default rootReducer;
